import { createI18n } from 'vue-i18n'
import bg from '@/languages/i18n/locales/bg.json'
import cs from '@/languages/i18n/locales/cs.json'
import da from '@/languages/i18n/locales/da.json'
import de from '@/languages/i18n/locales/de.json'
import el from '@/languages/i18n/locales/el.json'
import en from '@/languages/i18n/locales/en.json'
import es from '@/languages/i18n/locales/es.json'
import et from '@/languages/i18n/locales/et.json'
import fi from '@/languages/i18n/locales/fi.json'
import fr from '@/languages/i18n/locales/fr.json'
import ga from '@/languages/i18n/locales/ga.json'
import hi from '@/languages/i18n/locales/hi.json'
import hr from '@/languages/i18n/locales/hr.json'
import hu from '@/languages/i18n/locales/hu.json'
import it from '@/languages/i18n/locales/it.json'
import ja from '@/languages/i18n/locales/ja.json'
import lt from '@/languages/i18n/locales/lt.json'
import lv from '@/languages/i18n/locales/lv.json'
import mt from '@/languages/i18n/locales/mt.json'
import nb from '@/languages/i18n/locales/nb.json'
import nl from '@/languages/i18n/locales/nl.json'
import pl from '@/languages/i18n/locales/pl.json'
import pt from '@/languages/i18n/locales/pt.json'
import ro from '@/languages/i18n/locales/ro.json'
import sk from '@/languages/i18n/locales/sk.json'
import sl from '@/languages/i18n/locales/sl.json'
import sr from '@/languages/i18n/locales/sr.json'
import sv from '@/languages/i18n/locales/sv.json'
import tr from '@/languages/i18n/locales/tr.json'
import uk from '@/languages/i18n/locales/uk.json'

export default createI18n({
  locale: window.navigator.language,
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  legacy: false,
  messages: {
    bg,
    cs,
    da,
    de,
    el,
    en,
    es,
    et,
    fi,
    fr,
    ga,
    hi,
    hr,
    hu,
    it,
    ja,
    lt,
    lv,
    mt,
    nb,
    nl,
    pl,
    pt,
    ro,
    sk,
    sl,
    sr,
    sv,
    tr,
    uk,
  },
})

export const SUPPORT_LOCALES = import.meta.env.VITE_SUPPORTED_LOCALES.split(',')
